export function getEnumKeys(enumObj) {
    return Object.keys(enumObj).filter(key => isNaN(Number(key)));
}
